import { useTranslation } from 'react-i18next';
import ProfileField from '../../../components/common/ProfileField';
import Section from '../../../components/common/Section';
import type { Profile } from './model';

export interface ProfileInformationProps {
    profile: Profile;
    className?: string;
    expanded?: boolean;
}

const ProfileInformation = ({ profile, className, expanded = false }: ProfileInformationProps) => {
    const { t } = useTranslation('overallTraineeReport');

    const fieldContainerClassName = expanded ? 'flex flex-col gap-1' : 'flex justify-between text-base';
    const fieldValueClassName = expanded ? 'text-left font-semibold' : 'text-right font-semibold';

    return (
        <Section title={t('sections.profile.title')} className={className} accent="muted">
            <dl className={expanded ? 'grid grid-cols-2 gap-5 text-base sm:grid-cols-6' : 'space-y-2 text-xs'}>
                <ProfileField
                    label={t('sections.profile.fields.name')}
                    value={profile.name}
                    containerClassName={fieldContainerClassName}
                    valueClassName={fieldValueClassName}
                />
                <ProfileField
                    label={t('sections.profile.fields.age')}
                    value={profile.age}
                    containerClassName={fieldContainerClassName}
                    valueClassName={fieldValueClassName}
                />
                <ProfileField
                    label={t('sections.profile.fields.gender')}
                    value={profile.gender}
                    containerClassName={fieldContainerClassName}
                    valueClassName={fieldValueClassName}
                />
                <ProfileField
                    label={t('sections.profile.fields.height')}
                    value={profile.heightCm}
                    units={t('sections.profile.units.cm')}
                    containerClassName={fieldContainerClassName}
                    valueClassName={fieldValueClassName}
                />
                <ProfileField
                    label={t('sections.profile.fields.weight')}
                    value={profile.weightKg}
                    units={t('sections.profile.units.kg')}
                    containerClassName={fieldContainerClassName}
                    valueClassName={fieldValueClassName}
                />
                <ProfileField
                    label={t('sections.profile.fields.bmi')}
                    value={profile.bmi}
                    containerClassName={fieldContainerClassName}
                    valueClassName={fieldValueClassName}
                />
                {/* TODO: after backend support injury
                <ProfileField
                    label={t('sections.profile.fields.injury')}
                    value={profile.injury}
                    containerClassName={fieldContainerClassName}
                    valueClassName={expanded ? 'font-semibold' : 'max-w-[110px] text-right font-medium'}
                />
                */}
            </dl>
        </Section>
    );
};

export default ProfileInformation;
